import React from 'react'
import './services.css'
import { BiCheck } from 'react-icons/bi'

const Services = () => {
  return (
    <section id='services'>
      <h5>What I Offer</h5>
      <h2>Services</h2>

      <div className="container services__container">

        {/* Frontend Development */}
        <article className='service'>
          <div className="service__head">
            <h3>Frontend Development</h3>
          </div>

          <ul className='service__list'>
            <li>
              <BiCheck className='list-icon'/>
              <p>Modern Web UI Development using React</p>
            </li>

            <li>
              <BiCheck className='list-icon'/>
              <p>Responsive and Mobile Friendly Interfaces</p>
            </li>

            <li>
              <BiCheck className='list-icon'/>
              <p>Reusable Component Based Architecture</p>
            </li>

            <li>
              <BiCheck className='list-icon'/>
              <p>State Management (Jotai / Redux)</p>
            </li>

            <li>
              <BiCheck className='list-icon'/>
              <p>Performance Optimization & Clean UI</p>
            </li>
          </ul>
        </article>

        {/* Full Stack Development */}
        <article className='service'>
          <div className="service__head">
            <h3>Full Stack Development</h3>
          </div>

          <ul className='service__list'>
            <li>
              <BiCheck className='list-icon'/>
              <p>MERN Stack Application Development</p>
            </li>

            <li>
              <BiCheck className='list-icon'/>
              <p>REST API Development using Node.js & Express</p>
            </li>

            <li>
              <BiCheck className='list-icon'/>
              <p>Database Design with MongoDB</p>
            </li>

            <li>
              <BiCheck className='list-icon'/>
              <p>Authentication & Secure Backend Systems</p>
            </li>

            <li>
              <BiCheck className='list-icon'/>
              <p>Microservices Based Architecture</p>
            </li>
          </ul>
        </article>

        {/* Software Engineering */}
        <article className='service'>
          <div className="service__head">
            <h3>Software Engineering</h3>
          </div>

          <ul className='service__list'>
            <li>
              <BiCheck className='list-icon'/>
              <p>Scalable Web Application Architecture</p>
            </li>

            <li>
              <BiCheck className='list-icon'/>
              <p>Clean Code & Best Development Practices</p>
            </li>

            <li>
              <BiCheck className='list-icon'/>
              <p>Debugging & Performance Improvements</p>
            </li>

            <li>
              <BiCheck className='list-icon'/>
              <p>Integration with APIs and Microservices</p>
            </li>

            <li>
              <BiCheck className='list-icon'/>
              <p>Collaborative Agile Development</p>
            </li>
          </ul>
        </article>

      </div>
    </section>
  )
}

export default Services